import { io } from "socket.io-client";
import { showTost } from "./showTost";
import { getSocketBaseURL } from "./utils/backendUrl";

let socket;

export const initiateSocket = (token, showDebugToast) => {
  if (socket) {
    return socket;
  }
  socket = io(getSocketBaseURL(), {
    auth: {
      token: token
    },
    autoConnect: false
  });

  socket.on("connect", () => {
    console.log("Socket connected!");
    if (showDebugToast === "1" || showDebugToast === 1) {
      showTost({ title: "Socket Connected!" });
    }
  });

  socket.on("disconnect", () => {
    console.log("Socket disconnected!");
    if (showDebugToast === "1" || showDebugToast === 1) {
      showTost({ title: "Socket Disconnected!" });
    }
  });

  socket.on("chat_warning", (data) => {
    console.warn("Received chat_warning:", data);
    const msg = data?.error || "Warning: Message contains a restricted word!";
    showTost({ title: "Word Warning", message: msg, type: "error" });
  });

  socket.on("chat_blocked", (data) => {
    console.error("Received chat_blocked:", data);
    const msg = data?.error || "Chat privileges suspended due to violations!";
    showTost({ title: "Chat Suspended", message: msg, type: "error" });
  });

  socket.connect();
  return socket;
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};

export const getSocket = () => {
  return socket;
};

export const emitProfileAction = ({ profileId, action, fallback }) => {
  const activeSocket = getSocket();
  const clientActionId = `${Date.now()}-${profileId}-${action}-${Math.random().toString(36).slice(2, 10)}`;
  const payload = { profileId, action, client_action_id: clientActionId, clientActionId };
  if (!activeSocket || !activeSocket.connected) {
    return fallback ? fallback(payload) : Promise.reject(new Error("Socket is not connected"));
  }

  return new Promise((resolve, reject) => {
    activeSocket.timeout(5000).emit("profile_action", payload, (err, response) => {
      if (err || response?.status !== "success") {
        if (fallback) {
          fallback(payload).then(resolve).catch(reject);
          return;
        }
        reject(err || new Error(response?.error || "Profile action failed"));
        return;
      }
      resolve(response);
    });
  });
};
